import {navigate} from 'gatsby'
import * as account from '../../api/account'
import cookie from 'js-cookie'
import {TOKEN_KEY} from '../../stores/AppStore'

const logout = store => () => {
  const {token} = store.getState()
  if (!token) return
  return account
    .logout(token)
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })
    .then(() => {
      store.setState({
        token: null,
        accessToken: null,
        user: null,
        roles: [],
      })
      cookie.remove(TOKEN_KEY)
      navigate('/login', {
        replace: true,
      })
    })
    .catch(error => {
      cookie.remove(TOKEN_KEY)
      navigate('/login', {
        replace: true,
      })
    })
}

export default logout
